import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/customers',
}).lazy(() => import('./customers.index.lazy').then((d) => d.Route))
